import React from 'react';
import { AmbassadorCard } from './AmbassadorCard';
import { SparklesIcon } from 'lucide-react';
export function AmbassadorSection() {
  const ambassadors = [{
    name: 'Dr. Sarah Chen',
    title: 'Founder, Dog is Human',
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
    testimonial: 'After seeing thousands of dogs transform with our formula, I knew we had to share this solution with pet parents everywhere.',
    linkedin: 'https://linkedin.com',
    verified: true
  }, {
    name: 'Dr. James Wilson',
    title: 'Veterinary Nutritionist',
    image: 'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
    testimonial: "In my 20 years of practice, I've never seen a supplement with such consistent positive results. The science behind it is revolutionary.",
    linkedin: 'https://linkedin.com',
    verified: true
  }, {
    name: 'Emma Thompson',
    title: 'Professional Dog Trainer',
    image: 'https://images.unsplash.com/photo-1594744803329-e58b31de8bf5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
    testimonial: "I recommend The Daily Foundation Chew to all my clients. The difference in their dogs' behavior and overall well-being is remarkable.",
    instagram: 'https://instagram.com',
    linkedin: 'https://linkedin.com',
    verified: true
  }];
  return;
}